/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Tue May 02 2023
 **/

import { Icon } from "../Icon";

export default function Pin() {
	return (
		<Icon
			size={20}
			name="Pin16"
			css={{
				fill: "#fff",
				filter: "drop-shadow(0px 1px 4px rgba(0, 0, 0, 0.5))"
			}}
		/>
	);
}
